"use client";

import { useEffect, useState } from "react";

const DEADLINE = new Date("2026-08-26T03:00:00Z").getTime();

function calc(now: number) {
  const diff = Math.max(0, DEADLINE - now);
  return {
    days: Math.floor(diff / 86_400_000),
    hours: Math.floor((diff / 3_600_000) % 24),
    minutes: Math.floor((diff / 60_000) % 60),
    seconds: Math.floor((diff / 1_000) % 60),
  };
}

export function CountdownTimer() {
  const [time, setTime] = useState(() => calc(Date.now()));

  useEffect(() => {
    const id = window.setInterval(() => setTime(calc(Date.now())), 1000);
    return () => window.clearInterval(id);
  }, []);

  return (
    <div className="grid grid-cols-4 gap-4 sm:gap-6" aria-live="polite">
      <Unit label="dias" value={time.days} />
      <Unit label="horas" value={time.hours} />
      <Unit label="min" value={time.minutes} />
      <Unit label="seg" value={time.seconds} />
    </div>
  );
}

function Unit({ label, value }: { label: string; value: number }) {
  return (
    <div className="flex flex-col items-center rounded-2xl border border-white/10 bg-white/5 px-4 py-6 text-center backdrop-blur-sm">
      <span
        className="font-display text-3xl font-medium text-white tabular-nums sm:text-4xl lg:text-5xl"
        aria-hidden="true"
      >
        {String(value).padStart(2, "0")}
      </span>
      <span className="mt-2 text-xs uppercase tracking-[0.2em] text-mist">{label}</span>
      <span className="sr-only">{`${value} ${label}`}</span>
    </div>
  );
}
